module.exports = __webpack_public_path__ + "img/submit-success.b05031d7.png";